import {
  AlabasterSuede,
  BlackMesh,
  BlackSuede,
  CinderOrangeSuede,
  LogoAnimatedBlack,
  LogoAnimatedWhite,
  camoBrownGreen,
  camoGrey,
  camoOrange,
  camoRed,
  camoTan,
  fadeGreenGrey,
  fadePurple,
  fadeRedNavy,
  fadeSunset,
  skyBlue,
  skyGrey,
  skyPink,
  skyRed,
  snakeBlue,
  snakeGreen,
  snakeTan,
  speckleBlackWhite,
  speckleMulti,
  speckleTanBlack,
  speckleTanPink,
  galaxyBlue,
  galaxyPink,
  galaxyTeal,
  oregonOption1,
  oregonOption2,
  oregonOption3,
  oregonOption4,
  oregonOption5,
  oregonOption6,
  oregonOption7,
  oregonOption8,
  oregonOption9,
  oregonOption10,
  oklahomaOption1,
  oklahomaOption2,
  oklahomaOption3,
  oklahomaOption4,
  oklahomaOption5,
  oklahomaOption6,
  texasOption1,
  texasOption2,
  texasOption3,
  texasOption4,
  texasOption5,
  texasOption6,
} from './images'

const Images = {
  alabasterSuede: AlabasterSuede,
  blackMesh: BlackMesh,
  blackSuede: BlackSuede,
  cinderOrangeSuede: CinderOrangeSuede,
  LogoAnimatedBlack: LogoAnimatedBlack,
  logoAnimatedWhite: LogoAnimatedWhite,
  camoBrownGreen,
  camoGrey,
  camoOrange,
  camoRed,
  camoTan,
  fadeGreenGrey,
  fadePurple,
  fadeRedNavy,
  fadeSunset,
  skyBlue,
  skyGrey,
  skyPink,
  skyRed,
  snakeBlue,
  snakeGreen,
  snakeTan,
  speckleBlackWhite,
  speckleMulti,
  speckleTanBlack,
  speckleTanPink,
  galaxyBlue,
  galaxyPink,
  galaxyTeal,

  oregonOption1,
  oregonOption2,
  oregonOption3,
  oregonOption4,
  oregonOption5,
  oregonOption6,
  oregonOption7,
  oregonOption8,
  oregonOption9,
  oregonOption10,
  oklahomaOption1,
  oklahomaOption2,
  oklahomaOption3,
  oklahomaOption4,
  oklahomaOption5,
  oklahomaOption6,
  texasOption1,
  texasOption2,
  texasOption3,
  texasOption4,
  texasOption5,
  texasOption6,
}

export default Images
